module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_0.2e39bf49.png";